export default function FilterMaj() {
    if ($('.v-maj__table--filter').length > 0) {

        $('#versionSelect, #typeSelect').change(function () {
            var versionValue = ($('#versionSelect').val()) ? '.' + $('#versionSelect').val() : '';
            var typeValue = ($('#typeSelect').val()) ? '.' + $('#typeSelect').val() : '';
            var filterValue = versionValue + typeValue;

            $('#filterInput').val(filterValue);

            $('.table__item').hide(0);

            $('.table__item' + filterValue).show(0);
        });

    }
}
